import React from "react";

// Bloque de carga genérico.
export function Skeleton({ className = "", style }) {
  return (
    <div
      aria-hidden="true"
      className={`bg-black/[0.06] rounded-lg animate-pulse ${className}`}
      style={style}
    />
  );
}

/**
 * Esqueleto con la forma real de una tarjeta: imagen, dos líneas de texto y un
 * pie corto.
 *
 * Convivían cuatro idiomas distintos de carga —pulse con altura correcta,
 * esqueleto real, bloques vacíos y un «Cargando…» pelado— y tres páginas no
 * mostraban nada en absoluto. Reservar la forma final es lo que evita que el
 * contenido salte cuando llegan los datos.
 */
export function CardSkeleton({ media = true }) {
  return (
    <div className="bg-card rounded-3xl overflow-hidden border border-border">
      {media && <Skeleton className="aspect-video rounded-none" />}
      <div className="p-6 space-y-3">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-4/5" />
        <Skeleton className="h-3 w-1/3 mt-4" />
      </div>
    </div>
  );
}

/** Rejilla de esqueletos de tarjeta. */
export function CardGridSkeleton({ count = 3, media = true, className = "" }) {
  return (
    <div
      className={`grid sm:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} media={media} />
      ))}
    </div>
  );
}

/** Esqueleto de cabecera de sección: antetítulo + titular. */
export function HeadingSkeleton() {
  return (
    <div className="space-y-4 mb-12 max-w-2xl">
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-10 w-3/4" />
    </div>
  );
}

export default Skeleton;
